import payme_icon from "../assets/images/old_providers_icons/payme-icon.svg";
import click_icon from "../assets/images/old_providers_icons/click-icon.svg";
import uzum_icon from "../assets/images/old_providers_icons/uzum-icon.svg";
import anor_icon from "../assets/images/old_providers_icons/anor-icon.svg";
import navigator from "../assets/images/icons/navigator-icon.svg";
import backgroundSubtitle from "../assets/images/icons/rectangle.svg";
import locationIcon from '../assets/images/icons/location-icon.svg'
import banner from "../assets/images/banners/galaxy-banner.jpeg";
import payme_square_icon from "../assets/images/new_providers_icons/payme_icon.svg"
import click_square_icon from '../assets/images/new_providers_icons/click_icon.svg'
import uzum_square_icon from '../assets/images/new_providers_icons/uzum_icon.svg'
import anorbank_square_icon from '../assets/images/new_providers_icons/anorbank_icon.svg'
import alif_square_icon from '../assets/images/new_providers_icons/alif_icon.svg'
import oson_square_icon from '../assets/images/new_providers_icons/oson_icon.svg'
import default_banner from '../assets/images/defaults/default-banner.jpg'
import default_store from '../assets/images/defaults/default-store.png'
import inactive_uzum_square_icon from "../assets/images/inactive_providers_icons/grey_uzum_icon.png"
import inactive_anorbank_square_icon from "../assets/images/inactive_providers_icons/grey_anorbank_icon.png"
import inactive_click_square_icon from "../assets/images/inactive_providers_icons/grey_click_icon.png"

export const images = {
	payme_icon,
	click_icon,
	uzum_icon,
	anor_icon,
	banner,
	navigator,
	backgroundSubtitle,
	locationIcon,
	payme_square_icon,
	click_square_icon,
	uzum_square_icon,
	anorbank_square_icon,
	alif_square_icon,
	oson_square_icon,
	default_banner,
	default_store,
	inactive_uzum_square_icon,
	inactive_anorbank_square_icon,
	inactive_click_square_icon,
}
